import {useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/BreadcrumbsNavigation.tsx';
import {useCard} from '../hooks/useCard.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';


export const EditPage = () => {


    const {
        id: customerId,
        cardId
    } = useParams();


    if (typeof customerId === 'undefined') {
        throw new Error('customerId is required parameter')
    }

    if (typeof cardId === 'undefined') {
        throw new Error('componentId is required parameter');
    }

    const {
        record: component,
        loading,
        updateRecord,
    } = useCard(customerId, cardId);

    const {
        mode,
        tools,
    } = useEditPageTools();

    if (loading || !component) {
        return <PlatformLoader message='Loading application...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={component.name ? component.name : component.id}
            pageNavigation={<EditPageNavigation record={component}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Stack gap='lg'>
                    <Profile
                        record={component}
                    />
                </Stack>
                :
                <RecordForm
                    record={component}
                    handleSubmit={updateRecord}
                />
            }


        </FormPageLayout>
    );
};
